function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Playlists");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Add-to-playlist---1820x1024",
  transform: "translate(-924.000000, -673.000000)",
  fill: "#1E1F20"
}, React.createElement("g", {
  id: "popup",
  transform: "translate(660.000000, 565.000000)"
}, React.createElement("g", {
  id: 2,
  transform: "translate(249.000000, 85.000000)"
}, React.createElement("g", {
  id: "Icons/Close",
  transform: "translate(24.000000, 32.000000) rotate(-315.000000) translate(-24.000000, -32.000000) translate(16.000000, 24.000000)"
}, React.createElement("g", {
  id: "noun_Close_530778",
  transform: "translate(2.000000, 2.000000)"
}, React.createElement("path", {
  d: "M11.7983298,10.8558758 L6.94568343,6 L11.7983298,1.14412417 C12.0649587,0.87804878 12.0649587,0.465631929 11.7983298,0.199556541 L11.7983298,0.199556541 C11.5317009,-0.066518847 11.1184261,-0.066518847 10.8517972,0.199556541 L5.99915076,5.05543237 L1.14650437,0.21286031 C0.879875445,-0.0532150776 0.466600615,-0.0532150776 0.199971692,0.21286031 C-0.0666572307,0.478935698 -0.0666572307,0.89135255 0.199971692,1.15742794 L5.05261808,6 L0.199971692,10.8558758 C-0.0666572307,11.1219512 -0.0666572307,11.5343681 0.199971692,11.8004435 C0.466600615,12.0665188 0.879875445,12.0665188 1.14650437,11.8004435 L5.99915076,6.94456763 L10.8651286,11.8004435 C11.1317575,12.0665188 11.5450324,12.0665188 11.8116613,11.8004435 C12.0649587,11.5343681 12.0649587,11.1086475 11.7983298,10.8558758 Z",
  id: "Path"
})))))));

var SvgPlus = function SvgPlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plus.890a533f.svg";
export { ForwardRef as ReactComponent };